import { Modal } from "react-bootstrap"
import { modal as modalText, resume } from "../../../i18n/pt.json"
import * as S from "./styled"

const Resume = ({ handleShow }) => (
  <S.Deny onClick={handleShow} className="resume">
    <S.CancelText>{resume.cancel}</S.CancelText>
  </S.Deny>
)

export const Layout = ({ isResume, variation, handleDelete, show, handleShow, handleClose }) => {
  const { delete: text } = modalText

  return (
    <>
      {isResume ? (
        <Resume handleShow={handleShow} />
      ) : (
        <S.Exclude
          data-testid={variation ? "openDeleteVariation" : "openDeleteItemModal"}
          onClick={handleShow}
        >
          X
        </S.Exclude>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vtop"
        top
        backdrop="static"
        onClick={(e) => e.stopPropagation()}
        keyboard={false}
      >
        <S.Header closeButton>
          <S.Title>{text.title}</S.Title>
        </S.Header>

        <Modal.Body>
          <S.BodyText>{text.body}</S.BodyText>
        </Modal.Body>

        <S.Footer>
          <S.Deny onClick={handleClose}>
            <S.DenyText>{text.deny}</S.DenyText>
          </S.Deny>
          <S.Confirm data-testid="deleteItem" onClick={handleDelete}>
            {text.confirm}
          </S.Confirm>
        </S.Footer>
      </Modal>
    </>
  )
}
